/** @jsx jsx */
import { jsx, ThemeUIStyleObject } from '@theme-ui/core';

import { Button } from 'src/shared/components/button';
import { GoogleLogoIcon } from 'src/shared/components/icons';
import { NEARMECHECK_API_URL } from 'src/near-me-check/api/fetch-from-backend';
import { NEARMECHECK_ROUTES } from 'src/routes';
import { getClientBaseUrl } from 'src/shared/helpers/get-client-base-url';

type URLType = {
    search: URLSearchParams | string;
};

export const getGoogleOauthLink = () => {
    const uberallAppGoogleId =
        '135924523670-q99qdgqfshn6bj3osc51qesp4c5uhqtd.apps.googleusercontent.com';

    const redirectToUberallBackendURL = `${NEARMECHECK_API_URL}/auth/google/callback`;

    const clientBaseUrl = getClientBaseUrl();
    const redirectBackToClientURL = `${clientBaseUrl}#${NEARMECHECK_ROUTES.SELECT_LOCATION}`;

    const googleApisURL = 'https://www.googleapis.com/auth/';
    const requiredAccessScopes = ['business.manage', 'userinfo.profile', 'userinfo.email'];

    const googleOauthUrl: URLType = new URL('https://accounts.google.com/o/oauth2/v2/auth');
    const queryParams = {
        client_id: uberallAppGoogleId,
        redirect_uri: redirectToUberallBackendURL,
        scope: requiredAccessScopes.map((scope) => `${googleApisURL}${scope}`).join(' '),
        access_type: 'offline',
        prompt: 'consent select_account',
        response_type: 'code',
        state: redirectBackToClientURL,
    };

    googleOauthUrl.search = new URLSearchParams(queryParams);

    return googleOauthUrl.toString();
};

type GoogleConnectButtonProps = {
    children: React.ReactNode;
    block?: boolean;
    sx?: ThemeUIStyleObject;
};

const GoogleConnectButton = ({ children, ...props }: GoogleConnectButtonProps) => {
    const googleOauthLink = getGoogleOauthLink();

    return (
        <Button
            to={googleOauthLink}
            icon={<GoogleLogoIcon />}
            shouldOpenInSameTab
            uppercase
            {...props}
        >
            {children}
        </Button>
    );
};

export default GoogleConnectButton;
